import React from 'react';
import { Helmet } from 'react-helmet-async';

const FrontendDeveloper = () => {
  return (
    <div className="container">
      <Helmet>
        <title>Ariel Rotem | "Frontend Developer"</title>
        <meta name="description" content="System error. Ariel Rotem is a Backend/Infrastructure Engineer. But here is a perfectly centered div anyway." />
      </Helmet>
      <div className="mb-4">
        <h1 className="glitch" style={{ color: 'var(--accent-secondary)', fontSize: '2.5rem' }}>$ cat frontend_expertise.log</h1>
      </div>

      <div className="terminal-card text-center mb-4">
        <h3 className="mb-2" style={{ color: 'var(--accent-tertiary)' }}>&gt; ERROR: DID YOU MEAN 'BACKEND DEVELOPER'?</h3>
        <p className="mono">
          System detected an attempt to access frontend credentials. 
          Are you sure you wouldn't rather manage highly scalable distributed databases or orchestrate AI deployments instead?
        </p>
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '60px 20px',
        border: '1px dashed var(--text-secondary)'
      }}>
        <h4 className="mono text-center mb-4" style={{ color: 'var(--text-secondary)' }}>
          But if we must... Behold: a perfectly centered div. The true test of any frontend master.
        </h4>
        
        <div style={{
          width: '300px',
          height: '200px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'var(--bg-tertiary)',
          color: 'var(--accent-primary)',
          fontSize: '1.5rem',
          fontWeight: 'bold',
          border: '2px solid var(--accent-primary)',
          transform: 'rotate(2.8deg)', /* The Joke */
          fontFamily: 'var(--font-mono)',
          boxShadow: 'var(--glow-shadow)'
        }}>
          I am centered!
        </div>
      </div>
    </div>
  );
};

export default FrontendDeveloper;
